<template>
  <div class="material-item" :class="{'comment-competition-enabled': material.metadata.comment_competition_enabled}">
    <localized-link :to="{name: 'Material', params: {
        lang: $i18n.locale,
        slug: decodeURIComponent(material.slug),
        productCategory: productCategory,
        productGroup: productGroup,
        materialType: materialType
      } }">
      <div class="material-item-content p-4">
        <p class="material-info text-secondary text-uppercase mb-2">
          <span class="bold" v-if="material.material_purpose">{{material.material_purpose.name}}</span>
          <span class="bold" v-if="material.categories.material_type"> | {{material.categories.material_type.name}}</span>
          <span v-if="material.content_type"> | {{material.content_type.name}}</span>
        </p>
        <h3 class="text-primary text-uppercase bold mb-3 material-title"
            v-html="material.title.rendered || material.title"></h3>
        <div class="material-applications" v-if="material.acf.applications">
          <div v-for="application in material.acf.applications" :key="application.text"
               class="d-flex justify-content-start align-items-center">
            <img :src="application.icon" class="mr-3">
            <p v-html="application.text" class="m-0"></p>
          </div>
        </div>
      </div>
      <div class="material-picture"
          v-if="material.featured_image.medium"
          :style="`background-image:url(${material.featured_image.medium})`">
        <div v-if="material.metadata.comment_competition_enabled" class="competition-icon text-white">
          <img class="img-fluid icon-trophy filter-to-white"
               src="@/assets/icons/trophy.svg"/>
          <span class="competition-icon--text">{{$t('contest.contestArticle')}}</span>
        </div>
      </div>
    </localized-link>
  </div>
</template>
<script>
export default {
  props: {
    material: null,
    productCategory: null,
    productGroup: null,
    materialType: null,
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
.material-item {
  background-color: #F5F5F5;
  &.comment-competition-enabled {
    background-color: $light-tertiary;
  }
  > a {
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
  }
  .material-item-content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }
  .material-info {
    font-size: 13px;
  }
  .material-title {
    font-size: 24px;
  }
  .material-applications {
    margin-top: auto;
    width: 100%;
    font-size: 15px;
    > div {
      &:first-child p {
        font-weight: bold;
      }
      &:not(:last-of-type) {
        margin-bottom: .25em;
      }
    }
    img {
      max-width: 45px;
      width: 100%;
      filter: $filter-to-lightgrey;
    }
  }
  .material-picture {
    min-height: 200px;
    width: 100%;
    max-width: 250px;
    background-size: cover;
    background-position: center center;
    position: relative;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    .competition-icon {
      display: flex;
      align-items: center;
      background: #b1332796;
      padding: 5px 10px;
      &--text {
        font-size: 12px;
        display: inline-block;
        width: min-content;
        margin-left: 8px;
      }
      .icon-trophy {
        max-width: 25px;
        width: 25px;
      }
    }
  }
}
@include media-breakpoint-down(lg) {
  .material-item {
    .material-info {
      font-size: 11px;
    }
    .material-title {
      font-size: 20px;
    }
    .material-applications {
      font-size: 13px;
    }
    .material-picture {
      min-height: 200px;
      max-width: 200px;
    }
  }
}
@include media-breakpoint-down(sm) {
  .material-item {
    > a {
      flex-direction: column-reverse;
      align-items: center;
    }
    .material-picture {
      max-width: 100%;
    }
  }
}
</style>
